import React, { Component } from 'react'
import { TextInput } from '../shared/TextInput'

export default class SalesTax extends Component {
  render() {
    return (
      <div className={'tax-toggle'}>
        <div>
          <label>
            Sales Tax
          </label>
          <div
            onClick={() => this.props.toggle('collectSalesTax')}
            data-tip={ this.props.collectSalesTax ? 'On' : 'Off' }
            className={
              this.props.collectSalesTax
              ? 'on sales-tax toggle-button'
              : 'off sales-tax toggle-button'
            }>
            <div className='toggle-switch'/>
          </div>
        </div>
        <TextInput
          placeholderText={'Percentage'}
          inputName={'salesTax'}
          label={'Sales Tax'}
          onChange={this.props.salesTaxChange}
          extraClass={'percentage'}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Settings/SalesTax.jsx